import moment from "moment";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import ButtonIcon from "./buttonIcon";

import { Common } from "../../services/Common";
import { useRef, useState } from "react";

const DatePickerInput = (props: any) => {
  let dateSelected = props.dateSelected ? new Date(props.dateSelected) : null;
  let maxDate = props.maxDate ? new Date(props.maxDate) : null;
  let minDate = props.minDate ? new Date(props.minDate) : null;

  let className = props.className ?? "";
  let showDates = props.showDates ?? [];
  let label = props.label ?? "";
  let firstSelect = props.firstSelect ?? "";
  let disabled = props.disabled ?? false;

  const filterDate = (date: Date) => {
    return Common.filterDate(date, showDates);
  };

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  const handleCalenderPicker = () => setCalendarIsOpen(!calendarIsOpen);

  return (
    <>
      <div
        className={`SelectBox DatePickerInput ${
          className ? "" + className : ""
        }`}
      >
        {label ? <label htmlFor="">{label}</label> : <></>}
        <DatePicker
          open={calendarIsOpen}
          disabled={disabled}
          placeholderText={firstSelect}
          maxDate={maxDate}
          minDate={minDate}
          dateFormat="dd/MM/yyyy"
          filterDate={filterDate}
          selected={dateSelected}
          onChange={(date: Date) => {
            props.handleChange(moment(date).format("DD-MM-YYYY"));
            handleCalenderPicker();
          }}
          onFocus={() => handleCalenderPicker()}
          onBlur={() => handleCalenderPicker()}
        />
        {dateSelected ? (
          <ButtonIcon
            disabled={disabled}
            handleClick={() => props.handleChange("")}
            icon="close"
          />
        ) : (
          <div className="downBox">
            <ButtonIcon
              disabled={disabled}
              icon="calendar_month"
              handleClick={() => handleCalenderPicker()}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default DatePickerInput;
